<template>
  <div :class="{ 'has-error': validacao.$error }" class="form-group">
    <label v-if="exibeLabel">
      {{ label }} <sup>{{ labelSup }}</sup>
    </label>
    <select
      :id="id"
      :data-test-id="`select-${id}`"
      :name="id"
      :disabled="somenteLeitura"
      :value="valor"
      class="form-control"
      @change="atualizar($event.target)"
    >
      <option value="">Todos</option>
      <option
        v-for="perfil in perfis"
        :key="perfil._id"
        :value="perfil.descricao"
      >
        {{ perfil.descricao }}
      </option>
    </select>
    <div v-if="validacao.$dirty" class="help-block">
      <slot name="mensagensValidacao" />
    </div>
  </div>
</template>

<script>
import PERFIL from '@/constantes/controle_acesso/PERFIL'
import { campoMixin } from '@/mixins/CampoMixin'

export default {
  name: 'SelecionarPerfil',
  mixins: [campoMixin],
  props: {
    label: {
      type: String,
      default: 'Perfil',
    },
    id: {
      type: String,
      default: 'perfil',
    },
  },
  data() {
    return {
      perfis: PERFIL.valores,
    }
  },
}
</script>
